const EXPORT_BASE = "/dibapi/collection/export";

export const buildExportUrl = (params: {
    format: "docx" | "zip";
    resourceId: string;
    collectionId: string;
    topicIds: string[];
    labels?: string[];
    status?: string[];
}): string => {
    const qs = new URLSearchParams();
    qs.set("resourceId", params.resourceId);
    qs.set("collectionId", params.collectionId);
    qs.set("topics", params.topicIds.join(";"));
    if (params.labels?.length) qs.set("labels", params.labels.join(";"));
    if (params.status?.length) qs.set("status", params.status.join(";"));
    return `${EXPORT_BASE}/${params.format}?${qs.toString()}`;
};

export const downloadExport = async (url: string): Promise<void> => {
    const response = await fetch(url, {credentials: "include"});
    if (!response.ok) throw new Error(`Export failed: ${response.status}`);

    const disposition = response.headers.get("Content-Disposition");
    const filenameMatch = disposition?.match(/filename="?(.+?)"?$/);
    const filename = filenameMatch?.[1] ?? "export.docx";

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(objectUrl);
};
